export class ContactResponse{
    httpStatus: String;
    response: {
        id: String,
        codeResponse: String,
        response: String,
    }

    constructor(codigoError: string, mensajeError: string){
        this.httpStatus="0";
        this.response={
            id:"",
            codeResponse: codigoError,
            response:mensajeError,
        }
      }
      
}